import request from '@/axios';
/***********************账号管理 *******************************************************************/
// 账号管理列表
export const getEnterpriseUserList = (query) => {
  return request({
    url: '/lebo-user/page',
    method: 'GET',
    params: { ...query }
  })
}
// 账号新增
export const enterpriseUserAdd = data => {
  return request({
    url: `/lebo-user/submit`,
    method: "post",
    data
  })
}
// 账号修改(只修改账号状态)
export const enterpriseUserEdit = data => {
  return request({
    url: `/lebo-user/update`,
    method: "post",
    data
  })
}
// 重置密码
export const enterpriseUserReset = userIds => {
  return request({
    url: `/lebo-user/reset-password`,
    method: "post",
    params: {
      userIds,
    }
  })
}
// 删除
export const enterpriseUserRemove = ids => {
  return request({
    url: `/lebo-user/remove`,
    method: "post",
    params: {
      ids,
    }
  })
}

/***********************设备管理 *******************************************************************/
// 设备管理列表
export const getEnterpriseDeviceList = (query) => {
  return request({
    url: '/lebo-dongle/dongleinfo/page',
    method: 'GET',
    params: { ...query }
  })
}
// 设备绑定账号
export const deviceBindUser = data => {
  return request({
    url: `/lebo-dongle/dongleinfo/bind`,
    method: "post",
    data
  })
}
// 设备操作
export const eventPush = data => {
  return request({
    url: `/lebo-dongle/dongleinfo/event-push`,
    method: "post",
    data
  })
}
/***********************配置管理 *******************************************************************/
// 配置管理列表
export const getdongleConfigList = (query) => {
  return request({
    url: '/lebo-dongle/dongleconfig/page',
    method: 'GET',
    params: { ...query }
  })
}
// 配置管理新增
export const settingSubmit = data => {
  return request({
    url: `/lebo-dongle/dongleconfig/submit`,
    method: "post",
    data
  })
}
// 删除
export const enterpriseSettingRemove = ids => {
  return request({
    url: `/lebo-dongle/dongleconfig/remove`,
    method: "post",
    params: {
      ids,
    }
  })
}
// 启用配置
export const enterpriseSettingUse = id => {
  return request({
    url: `/lebo-dongle/dongleconfig/enable`,
    method: "post",
    params: {
      id,
    }
  })
}
/***********************推送管理 *******************************************************************/
//推送管理列表
export const getDongletemplatemessage = (query) => {
  return request({
    url: '/lebo-dongle/dongletemplatemessage/page',
    method: 'GET',
    params: { ...query }
  })
}









/***********************推送管理 *******************************************************************/
// 通用上传
export const putFile = (data) => {
  return request({
    url: '/lebo-resource/oss/endpoint/put-file',
    method: 'post',
    data
  })
}

